import { Component, AfterViewChecked, AfterViewInit } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-employee",
  template: `
    <div [class]="'fieldEmployee ' + field.className">
      <kreform-field
        *ngFor="let f of field.fieldGroup"
        [field]="f"
      ></kreform-field>
      <ng-content></ng-content>
    </div>
  `,
  host: {
    "[class]": 'field.className || ""',
    cdkDrag: ""
  }
})
export class KreFormFieldEmployee extends FieldType {}
